<template>
  <!-- 故障码查询 -->
  <div class="dtc-search">
    <a-modal
      okText="确认"
      cancelText="取消"
      title="故障码查询"
      :width="1000"
      v-model="brokenCodeVisible"
      @ok="handleConfirmClick"
      @cancel="handleCancelClick"
    >
      <div class="c-h-b-flex">
        <div class="w-25 c-h-b-flex">
          <span class="w-45">模块：</span>
          <a-select
            style="width:100%;"
            @change="handleModuleChange"
            :value="getBrokenCodeObj.dtcModuleDictId"
          >
            <a-select-option value>请选择</a-select-option>
            <a-select-option
              v-for="item in failureModuleList"
              :value="item.id"
              :key="item.id"
            >{{item.name}}</a-select-option>
          </a-select>
        </div>
        <div class="w-25 c-h-b-flex">
          <span class="w-45">故障码：</span>
          <a-input v-model="getBrokenCodeObj.code"></a-input>
        </div>
        <div class="w-25 c-h-b-flex">
          <span class="w-45">故障码描述：</span>
          <a-input v-model="getBrokenCodeObj.description"></a-input>
        </div>
        <div class="w-10">
          <a-button type="primary" @click="handleDtcSearch">查询</a-button>
        </div>
      </div>
      <div class="m-top-20">
        <a-table
          :rowSelection="brokenCodeSelection"
          :columns="brokenCodeColumns"
          :dataSource="brokenCodeList"
          :pagination="brokenCodePagination"
          @change="handleDtcSearchChange"
        ></a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  props: ["visible", "vehicleId"],
  data() {
    return {
      currentObj: "",
      brokenCodeColumns: [
        {
          key: "moduleName",
          dataIndex: "moduleName",
          title: "模块"
        },
        {
          key: "failureCode",
          dataIndex: "failureCode",
          title: "故障码"
        },
        {
          key: "failureDesc",
          dataIndex: "failureDesc",
          title: "故障码描述"
        }
      ],
      brokenCodeSelection: {
        type: "radio",
        onChange: this.brokenCodeSelectionChange
      }
    };
  },
  methods: {
    ...mapMutations([]),
    handleModuleChange: function(value) {
      this.getBrokenCodeObj.dtcModuleDictId = value;
    },
    brokenCodeSelectionChange: function(rowKeys, rows) {
      rowKeys;
      rows;
      this.currentObj = rows[0];
    },
    handleCancelClick: function() {
      this.$emit("modalCancel");
      this.getBrokenCodeObj.dtcModuleDictId = "";
      this.getBrokenCodeObj.description = "";
      this.getBrokenCodeObj.code = "";
    },
    handleConfirmClick: function() {
      this.brokenCodeVisible = false;
      this.$emit("modalConfirm", { obj: this.currentObj });
      this.getBrokenCodeObj.dtcModuleDictId = "";
      this.getBrokenCodeObj.description = "";
      this.getBrokenCodeObj.code = "";
    },
    // 搜索
    handleDtcSearch: function() {
      if(this.vehicleId){
        this.getBrokenCodeObj.vehicleId = this.vehicleId;
      }
      let params = {
        moduleDictId: this.getBrokenCodeObj.dtcModuleDictId,
        failureDesc: this.getBrokenCodeObj.description,
        failureCode: this.getBrokenCodeObj.code,
        vehicleId: this.getBrokenCodeObj.vehicleId
      };
      this.$store.dispatch("searchBrokenCode", params);
    },
    // 分页
    handleDtcSearchChange: function(...arg) {
      let [pagination] = [...arg];
      if(this.vehicleId){
        this.getBrokenCodeObj.vehicleId = this.vehicleId;
      }
      Object.assign(pagination, {
        moduleDictId: this.getBrokenCodeObj.dtcModuleDictId,
        failureDesc: this.getBrokenCodeObj.description,
        failureCode: this.getBrokenCodeObj.code,
        vehicleId: this.getBrokenCodeObj.vehicleId
      });
      this.$store.dispatch("searchBrokenCode", pagination);
    }
  },

  mounted() {
    let params = ["module"]
    this.$store.dispatch("getDictType", params.join(","));
    this.$store.dispatch("getTechSupportType", {});
    // this.$store.dispatch("getBrokenCode", {});
    if(this.vehicleId){
      this.$store.dispatch("dtcModuleListSearch", {id: this.vehicleId});
    }else{
      this.$store.dispatch("dtcModuleListSearch", {id: 0});
    }
  },
  watch: {
    vehicleId(val){
      if(val){
        this.$store.dispatch("dtcModuleListSearch", {id: this.vehicleId});
      }else{
        this.$store.dispatch("dtcModuleListSearch", {id: 0});
      }
    }
  },
  computed: {
    brokenCodeVisible: {
      get: function() {
        return this.visible;
      },
      set: function(val) {
        console.log(val);
      }
    },
    ...mapState({
      brokenCodePagination: state => state.utils.dtcSearchPagination,
      getBrokenCodeObj: state => state.utils.getBrokenCodeObj,
      brokenCodeList: state => state.utils.brokenCodeList,
      failureModuleList: state => state.utils.failureModuleList
    }),
    ...mapGetters(["dtcModuleList"])
  },
  components: {}
};
</script>

<style lang='less'>
</style>

